module.exports = __webpack_public_path__ + "static/media/flixbus.67f5f3c1.svg";